import React, { useEffect, useState } from "react";

const ButtonMode = () => {
  const [theme, setTheme] = useState(
    localStorage.getItem("currentMode") ?? "dark"
  );

  useEffect(() => {
    if (theme === "light") {
      document.body.classList.remove("dark");
      document.body.classList.add("light");
    } else {
      document.body.classList.remove("light");
      document.body.classList.add("dark");
    }
  }, [theme]);

  return (
    // L'attribut itemType de l'élément <button> est défini sur
    //"http://schema.org/Action" pour spécifier le type de l'action.
    <button
      onClick={() => {
        localStorage.setItem(
          "currentMode",
          theme === "dark" ? "light" : "dark"
        );
        setTheme(localStorage.getItem("currentMode"));
      }}
      className="mode flex"
      itemScope
      itemType="https://schema.org/Action"
    >
      {theme === "dark" ? (
        <span className="icon-moon-o" itemProp="icon"></span>
      ) : (
        <span className="icon-sun" itemProp="icon"></span>
      )}
    </button>
  );
};

export default ButtonMode;
